export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14776.68eabcb9.jpg";